import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails.tsx';
import { IndentedSections } from '@openx/components-core/lib/IndentedSection/IndentedSections.tsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { BrandsField } from './ParticipantBrandsField.tsx';
import type { ParticipantDefaultProps } from './types.ts';

export const ParticipantTTD = ({
  labels,
  getBuyerName,
  selectedSeatIds,
  mainBuyer,
  brands,
  selectedBrandIds,
  demandPartnerValue,
  mediaSpendGoalValue,
}: ParticipantDefaultProps) => {
  const { t } = useTranslation();

  const seatNames = useMemo(() => {
    return selectedSeatIds.map(getBuyerName);
  }, [selectedSeatIds, getBuyerName]);

  return (
    <>
      <FieldDetails title={labels.demandPartner} value={demandPartnerValue} />
      <IndentedSections>
        <FieldDetails title={labels.mainBuyer} value={getBuyerName(mainBuyer)} />
        <FieldDetails title={labels.seatIDs} value={seatNames} />
        {mediaSpendGoalValue && (
          <Box sx={{ mt: 2.5, mb: 2 }}>
            <Typography variant="overline" sx={{ textTransform: 'uppercase', display: 'block', mb: 1.5 }}>
              {t('TTD Financial Terms')}
            </Typography>
            <FieldDetails title={t('Media Spend Goal')} value={mediaSpendGoalValue} />
          </Box>
        )}
      </IndentedSections>
      {brands && <BrandsField labels={labels} selectedBrandIds={selectedBrandIds} brands={brands} />}
    </>
  );
};
